import { Flex, Text } from "@chakra-ui/react";
import { ReactNode } from "react";
import { FlexProps } from "@chakra-ui/react";

export function FlightSummaryAdditionalInfo({
  boxBackground,
  icon,
  title,
  description,
  ...props
}: FlexProps & {
  boxBackground: string;
  icon?: ReactNode;
  title: string;
  description?: string | 0;
}) {
  return (
    <Flex direction="column" align="baseline" {...props}>
      <Flex direction="row" justify="center" align="center" gap={3}>
        {icon && (
          <Flex boxSize={10} bg={boxBackground} borderRadius="md" justify="center" align="center">
            {icon}
          </Flex>
        )}
        <Flex direction="column">
          <Text fontSize="sm" color="greyscale.600">
            {title}
          </Text>
          <Text mt={1} data-testid={title} fontSize="md">
            {description}
          </Text>
        </Flex>
      </Flex>
    </Flex>
  );
}
